import { FormEvent, ReactElement, useRef, useState } from "react";
import { Link } from "react-router-dom";
import NewButton from "../../../components/Atomos/Buttons/newButton";
import { DealmakerActor, DealmakerDetail, submitDealmakerContact } from "../../../Services/DealmakerCatalog";
import { commentDraft, logoUrl } from "../dealmakerDisplay";

interface DealmakerContactProps {
  deal: DealmakerDetail;
  actor: DealmakerActor;
}

export default function DealmakerContact({ deal, actor }: DealmakerContactProps): ReactElement {
  const formRef = useRef<HTMLFormElement>(null);
  const [method, setMethod] = useState("1");
  const [comment, setComment] = useState(commentDraft(actor.firmName));
  const [errors, setErrors] = useState<string[]>([]);
  const [saved, setSaved] = useState(false);
  const [sending, setSending] = useState(false);

  async function onSubmit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setSending(true);
    try {
      const result = await submitDealmakerContact(actor, String(deal.dealId), comment.trim(), method);
      if (!result.saved) {
        setErrors(result.errors ?? ["The request could not be saved."]);
        return;
      }
      setErrors([]);
      setSaved(true);
    } catch {
      setErrors(["The request could not be saved."]);
    } finally {
      setSending(false);
    }
  }

  if (saved) {
    return (
      <section>
        <h2 className="dealmaker-heading">Contact Firm</h2>
        <p className="dealmaker-thanks">Thank you for your submission. You should be contacted soon. You will receive a copy of your request in your inbox.</p>
        <Link className="dealmaker-overview-link" to="/dealmaker">Ok</Link>
      </section>
    );
  }

  return (
    <section>
      <h2 className="dealmaker-heading">Contact Firm</h2>
      <div className="dealmaker-toolbar">
        <div className="dealmaker-tabs">
          <Link to={`/dealmaker?view=1&action=view&dealid=${deal.dealId}`}>Overview</Link>
          <span className="dealmaker-tab-active">Contact Firm</span>
        </div>
        {deal.logoName ? <img className="dealmaker-detail-logo" src={logoUrl(deal.logoName)} alt="" /> : null}
      </div>
      <p><b>Re</b>: {deal.title}</p>
      <p><b>Firm: </b>{deal.companyName}</p>
      <p><b>Contact Name: </b><a href={`/profile/${deal.contactSlug}/${deal.contactId}`}>{deal.contactName}</a></p>
      <p><b>Email: </b><a href={`mailto:${deal.contactEmail}`}>{deal.contactEmail}</a></p>
      <p><b>Phone: </b>{deal.contactPhone}</p>
      <p className="mt-4">
        <span className="dealmaker-label">{actor.name}</span><br />
        {actor.title}<br />
        {actor.firmName}<br />
        {actor.email}<br />
        {actor.phone}
      </p>
      {errors.length > 0 ? (
        <div className="dealmaker-error">
          <p>Please correct the following error(s)</p>
          {errors.map((error) => <p key={error}>{error}</p>)}
        </div>
      ) : null}
      <form ref={formRef} onSubmit={(event) => { void onSubmit(event); }}>
        <p>Preferred Method of Communications</p>
        <label className="mr-4"><input type="radio" name="method" value="1" checked={method === "1"} onChange={() => setMethod("1")} /> Email</label>
        <label><input type="radio" name="method" value="0" checked={method === "0"} onChange={() => setMethod("0")} /> Phone</label>
        <p className="dealmaker-label mt-4">Comments and Questions*</p>
        <textarea className="dealmaker-comment" rows={6} value={comment} onChange={(event) => setComment(event.target.value)} />
        <div className="mt-4">
          <NewButton text="Submit" color="primary" style="filled" disabled={sending} onClick={() => formRef.current?.requestSubmit()} />
        </div>
      </form>
    </section>
  );
}
